import { FormattedMessage } from 'react-intl'

import { BankEligibilityBeneficialOwner } from '@/domains/Business/types'
import { Button } from '@/shared/ui'

type Props = {
  owner: BankEligibilityBeneficialOwner
  onClick: (id: string) => void
}

export const OwnerActionCell = ({ owner, onClick }: Props) => {
  const hasUploadedDocument = !!owner.document

  return (
    <div className="flex items-center">
      <Button
        onClick={(e) => {
          e.stopPropagation()
          onClick(owner.id)
        }}
        variant={hasUploadedDocument ? 'secondary' : 'default'}
        size="xs"
      >
        {hasUploadedDocument ? (
          <FormattedMessage id="action.edit" defaultMessage="Edit" />
        ) : (
          <FormattedMessage id="action.start" defaultMessage="Start" />
        )}
      </Button>
    </div>
  )
}
